import React, { useRef } from "react";
import PropTypes from "prop-types";
import { constants } from "@utils/js/constant";
import { Constants as ActisConstants } from "@constants";
import InputBase from "@mui/material/InputBase";
import IconButton from "@mui/material/IconButton";
import { Box } from "@mui/material";
import config from "@config";
import { useSearchParams } from "react-router-dom";
import { ACTIS_REPORTING } from "@utils/js/actis";
import { debounce } from "@utils/js/utilities";
import styles from "./styles";

const {
  LABELS: { HEADER, STYLE_PREFIX: stylepx },
} = constants;

const {ACTIS: {EVENT_DATA: { SEARCH_METRIC }}} = ActisConstants

function SearchBar() {
  const inputRef = useRef(null);
  const [searchParams, setSearchParams] = useSearchParams();

  const debounceSearchChangeActisCall = useRef(
    debounce((keyword) => {
      ACTIS_REPORTING.SEARCH.push({
        ...SEARCH_METRIC,
        activityValue: keyword,
      });
    }, 1000)
  ).current;

  const handleSearchChange = (e) => {
    const newParams = new URLSearchParams(searchParams);
    const isEmptyString = e.target.value?.trim();
    const currentSearchQuery = searchParams.get("query");

    if (!isEmptyString?.length && !currentSearchQuery?.length) {
      return
    }

    const cleanedValue = e.target.value?.replace(/\s{2,}/g, " ");
    if(cleanedValue)
      newParams.set("query", cleanedValue);
    else
      newParams.delete("query");

    setSearchParams(newParams);

    debounceSearchChangeActisCall(cleanedValue);
  };

  const sectionStylePx = `${stylepx}-search-input`;

  return (
    <Box className={sectionStylePx} sx={styles.root}>
      <IconButton type="button" sx={styles.searchIcon} aria-label="search">
        <img src={`${config.S3_ASSET_PATH}/header/SearchIcon.svg`} />
      </IconButton>
      <InputBase
        sx={styles.searchInput}
        inputRef={inputRef}
        value={searchParams.get("query") || ""}
        autoFocus
        placeholder={HEADER.SEARCH_PLACEHOLDER}
        inputProps={{
          "aria-label": HEADER.SEARCH_PLACEHOLDER,
        }}
        onChange={handleSearchChange}
      />
    </Box>
  );
};

export default SearchBar;
